
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/legal/privacy",
      function () {
        return require("private-next-pages/[locale]/legal/privacy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/legal/privacy"])
      });
    }
  